import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import getModulePadding from "helpers/get-module-padding";

const itemImageSize = (length) => {
    if (!length) return "max-w-full";

    return length === 1 ? "max-w-[500px]" : "max-w-full";
};

const CollectionSizeGuide = ({ data }) => {

    return (
        <div className={`container collection-size-guide`}>
            <div className={`flex flex-col text-blue-700`}>
                <h2 className="collection-size-guide__title">
                    {data?.title}
                </h2>
                <h3 className="collection-size-guide__subtitle">
                    {data?.subtitle}
                </h3>
                <div className="collection-size-guide__items">
                    {data?.sizeTypes?.map((sizeType) => (
                        <div key={sizeType?.description} className="collection-size-guide__item">
                            <div className={`${itemImageSize(data?.sizeTypes?.length)} collection-size-guide__item-image`}>
                                <Image image={sizeType?.image?.asset} />
                            </div>
                            <div className="collection-size-guide__item-info">
                                <p className="collection-size-guide__item-description">{sizeType?.description}</p>
                                <div className="collection-size-guide__item-info-row">
                                    <p className="collection-size-guide__item-sizes">{sizeType?.sizes?.title}</p>
                                    <p className="collection-size-guide__item-height">{sizeType?.height}</p>
                                </div>
                            </div>
                            <div className="collection-size-guide__item-sizes-links">
                                {sizeType?.sizes?.links?.map((size) => (
                                    <Link key={size?.url} className="collection-size-guide__item-size-link" to={size?.url}>
                                        {size?.link}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CollectionSizeGuide;
